// extracted by mini-css-extract-plugin
export var gif = "_ec-0";